import { Component, Input } from '@angular/core';

@Component({
    selector: 'bw-bui-column-legacy',
    templateUrl: './bui-column.component.html',
    styleUrls: ['./bui-column.component.scss'],
    standalone: false
})
export class BuiColumnComponentLegacy {

  @Input() rows: any[] = [];
  @Input() rowSpacing: number = 0;

}
